import * as React from 'react';
import * as moment from 'moment';
import { eachDay } from 'date-fns';
import { compose, lifecycle, withState, withPropsOnChange, withHandlers } from 'recompose';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { getCurrentEmployee, getDayPlansForCurrentUser } from '@modules/hr-dayplans/_dayplansActions';
import EmployeeCalendar from '@components/employeeCalendar/EmployeeCalendar';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Loader } from '@components/loader';

const enhance = compose(
  breadcrumbs([{ label: 'Personalistika - moje plány' }]),
  withState('isFetching', 'toggleFetching', false),
  withState('dayPlans', 'fetchDayPlans', []),
  withState('employees', 'fetchEmployees', []),
  withState('currentMonth', 'setCurrentMonth', new Date()),
  withPropsOnChange(['currentMonth'], ({ currentMonth }) => ({
    from: moment(currentMonth)
      .startOf('month')
      .utc()
      .format(),
    to: moment(currentMonth)
      .endOf('month')
      .utc()
      .format()
  })),
  withPropsOnChange(['from', 'to'], ({ from, to }) => ({
    days: eachDay(from, to)
  })),
  withHandlers({
    fetchDayPlansForUser: ({ from, to, fetchEmployees, fetchDayPlans, toggleFetching }) => async () => {
      toggleFetching(true);
      await getCurrentEmployee().then(
        async employee => {
          await getDayPlansForCurrentUser(from, to).then(
            dayPlans => {
              fetchEmployees([employee]);
              fetchDayPlans([{ [employee.id]: dayPlans }]);
            },
            e => console.debug(e)
          );
        },
        e => console.debug(e)
      );
      toggleFetching(false);
    }
  }),
  lifecycle<any, any>({
    async componentDidMount() {
      this.props.fetchDayPlansForUser();
    },
    componentWillReceiveProps({ from, to }: any) {
      if (this.props.from !== from || this.props.to !== to) {
        this.props.fetchDayPlansForUser();
      }
    }
  })
);

const View: React.SFC<any> = ({ dayPlans, employees, days, currentMonth, setCurrentMonth, isFetching }) => (
  <div>
    <div className="hr-calendar-navigation">
      <Button
        label={`« ${moment(currentMonth)
          .subtract(1, 'M')
          .format('MMMM Y')}`}
        onClick={() =>
          setCurrentMonth(
            moment(currentMonth)
              .subtract(1, 'M')
              .format()
          )
        }
      />
      <Button
        label={`Aktuální měsíc (${moment(new Date()).format('MMMM')})`}
        onClick={() => setCurrentMonth(new Date())}
      />
      <Button
        label={`${moment(currentMonth)
          .add(1, 'M')
          .format('MMMM Y')} »`}
        onClick={() =>
          setCurrentMonth(
            moment(currentMonth)
              .add(1, 'M')
              .format()
          )
        }
      />
    </div>
    {isFetching && <Loader />}
    <EmployeeCalendar dayPlans={dayPlans} employees={employees} days={days} showEndOfWeekCalendars={false} />
  </div>
);

export const MyPlans = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-plans/MyPlans.tsx